<template>
  <v-dialog v-model="showDialog" max-width="700px" persistent>
    <v-card flat>
      <v-icon
        class="close"
        @click.prevent="
          showDialog = false
          $emit('close')
        "
        >$sl-close</v-icon
      >
      <h2>{{ title }}</h2>
      <workplaces-list
        :workplaces="workplaceList"
        @item-click="check($event)"
        actionType="checkbox"
        :withSearch="false"
        flat
        :model="workplace"
      ></workplaces-list>

      <ActionButton class="mt-4" :isDisabled="!isEditable" @click="linkWorkplace" actionIcon="$sl-link">{{
        $t('labels.link')
      }}</ActionButton>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkplacesList from '@/components/Common/Workplace/WorkplacesList'
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import filter from 'lodash/filter'
import xor from 'lodash/xor'

// @group Company
// LinkWorkplaceModal component
export default {
  name: 'LinkWorkplaceModal',
  props: {
    // Should dialog be showed
    showModal: false,
    // modal title
    title: {
      // `String`
      type: String,
      // The default value is: `function returning a string`
      default: function () {
        return this.$t('labels.link-workplace')
      }
    },
    // save modal button
    savebtn: {
      // `String`
      type: String,
      // The default value is: `function returning a string`
      default: function () {
        return this.$t('labels.link')
      }
    },
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true
    },
    // cancel modal button
    cancelBtn: {
      // `String`
      type: String,
      // The default value is: `function returning a string`
      default: function () {
        return this.$t('labels.cancel')
      }
    },
    //icon
    icon: {
      // `String`
      type: String,
      // cancel modal button
      default: '$sl-link'
    },
    // Company id
    companyId: {
      // `Number`
      type: Number,
      // The default value is: `null`
      default: null
    },
    // Instructors array
    linkedWp: {
      // `Array`
      type: Array,
      // The default value is: `[]`
      default: null
    }
  },

  data: () => ({
    showDialog: false,
    workplace: [],
    companyWorkplaces: []
  }),

  components: {
    ActionButton,
    WorkplacesList
  },

  computed: {
    /**
     * @vuese
     * Used to get workplace list from company workplaces array
     */
    workplaceList() {
      return filter(
        this.companyWorkplaces.map(o => {
          return {
            id: o.id,
            name: o.name,
            postalAddress1: o.postalAddress1,
            postalZip: o.postalZip,
            postalCity: o.postalCity
          }
        }),
        function (o) {
          return o.id !== null
        }
      )
    }
  },

  created() {
    this.init()
  },

  watch: {
    /**
     * @vuese
     * Used to watch show prop and open modal
     */
    showModal(val) {
      this.showDialog = val
      this.init()
      // this.workplace = []
    },
    /**
     * @vuese
     * Used to watch companyId prop and call init function
     */
    companyId() {
      this.init()
    }
  },

  methods: {
    /**
     * @vuese
     * Used to fetch workplaces
     * @arg The argument is an integer value representing company id
     */
    init() {
      let id = null

      this.companyId != null ? (id = this.companyId) : (id = this.$route.params.id)
      this.workplace = []
      //this.workplace.push(this.linkedWp[0].id)
      if (this.linkedWp) {
        this.linkedWp.forEach(element => {
          this.workplace.push(element.id)
        })
      }

      //this.workplace[0] = {id: 1}

      API.getWorkplaces(Number(id))
        .then(res => {
          this.companyWorkplaces = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * @vuese
     * Used to andle prevents propagation of the event
     */
    check: function (e) {
      this.workplace = xor(this.workplace, [e.id])
      e.cancelBubble = true
    },
    /**
     * @vuese
     * Used to link workplace
     */
    linkWorkplace() {
      let wp = []
      this.workplace.forEach(w => {
        this.companyWorkplaces.forEach(element => {
          if (element.id == w) {
            wp.push(element)
          }
        })
      })
      // Fire Workplace object
      // @arg The argument is object representing Workplace
      this.$emit('linked', wp)
      //Used to close the dialog
      this.showDialog = false
    }
  }
}
</script>

